// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__GF4V9","title":"header_title__MYgC_","close":"header_close__5MiGD"};